(ns com.theplantscape.plant-web.pages.polyculture.forms
  (:require
   [com.theplantscape.plant-web.components.forms.core
    :refer [update-atom-ns-hm]]
   [com.theplantscape.web-ui.tailwind.form.elements.checkbox :as c]
   [com.theplantscape.web-ui.tailwind.form.elements.input :as f]
   [reagent.core :as r]))

(defn polyculture-settings-form [title values cfg]
  (let [form-state (r/atom {:disabled false
                            :mode :login})
        form-values (r/atom {:values (select-keys values [:polyculture/title
                                                          :polyculture/description
                                                          :polyculture/public])})
        form (partial update-atom-ns-hm :polyculture form-values)
        on-submit (fn [e]
                    (prn "Save polyculture settings")
                    (.preventDefault e)
                    ((:submit-fn cfg) (:values @form-values))
                    ((:close-fn cfg)))]

    (fn [title values cfg]
      [:div.absolute.w-full.flex.justify-center {:style {:class "bg-gray-100" :height "600px"}}
       [:div.bg-white.w-full
        {:style {:z-index 999} :class "w-1/2"}
        (when (-> @form-state :disabled)
          [:svg.animate-spin.-ml-1.mr-3.h-6.w-6.text-black
           {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
           [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "#000000" :stroke-width "4"}]
           [:path.opacity-75 {:fill "#000000" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]])

        [:div.bg-white.shadow.w-full.rounded-lg.divide-y.divide-gray-200
         [:div.px-5.py-7
          [:h1.font-bold.text-center.text-2xl.testmb-5 title]
          [:form {:on-submit on-submit}
           [f/ui-form-input
            (r/cursor form-values [:values :polyculture/title])
            {:name "title"
             :label "Polyculture title"
             :tooltip "Title of your design"
             :placeholder "Title"
             :store-fn form}]

           [f/ui-form-input
            (r/cursor form-values [:values :polyculture/description])
            {:name "description"
             :label "Polyculture description"
             :tooltip "Describe your polyculture"
             :placeholder ""
             :store-fn form}]

           [c/ui-form-boolean
            (r/cursor form-values [:values :polyculture/public])
            {:name "public"
             :default "true"
             :label "Allow anyone to view"
             :tooltip "Allow anyone to view ?"
             :store-fn form}]

           [:button.mb-4.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center {:class "w-1/3" :type "submit" :disabled (-> @form-state :disabled)}  "Save"]
           [:button.ml-4.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-half.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center {:class "w-1/3" :type "reset" :on-click (:close-fn cfg)} "Close"]]]]]])))
